module.exports = __webpack_public_path__ + "static/img/prize_gift.4943692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prize_gift.png
// module id = /s4w
// module chunks = 1